<div id="page-container">
  <div id="content-wrap">
    <div class="fullScreen">
      <headband [accountName]="accountName" [maxVoters]="maxVoters" [hasHotline]="hasHotline"
        (hotlinePopupChange)="hotlinePopup = $event" (optionsPopupChange)="changeSubscription()"
        (buyPopupEvent)="shouldBuyCredits = $event"></headband>

    </div>

    <div class="flex content-evenly">
      <div>
        <img src="assets/v8te.png" id="logo">
      </div>
      <main class="w-70p p-30 h-full">
        <div class="title-holder mt-30 w-full">
          <div class="flex-col">
            <h1 class="description dark-blue no-margin">Tableau de bord des scrutins</h1>
            <p class="text-sm dark-gray no-margin">Retrouvez ici tous vos scrutins classés par état : en préparation,
              programmés, en cours ou terminés. Depuis
              cette vue, vous pouvez créer un nouveau scrutin, suivre l’avancement de vos opérations et accéder
              rapidement aux paramétrages détaillés.</p>
          </div>

          <div style="position: relative; display: inline-block;">
            <button
              *ngIf="plannedPolls.length != 0 || runningPolls.length != 0 || closedPolls.length != 0 || draftPolls.length != 0"
              (click)="pollCreationOptions(false)" style="min-width: 220px;" class="action-button">CRÉER UN SCRUTIN</button>
            <div *ngIf="prePolToast" class="toaster p-20"
              style="position: absolute; top: 100%; left: 0; width: 100%; margin-top: 10px; background-color: white; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.2); z-index: 1000;">
              <div class="flex align-items-center gap-5 poll-type-item" (click)="redirectToPap()">
                <div class="play"></div>
                <p class="pastel-pink no-margin">Election C.S.E</p>
              </div>
              <div class="flex align-items-center gap-5 poll-type-item mt-20" (click)="newPoll()">
                <div class="play"></div>
                <p class="lavender no-margin">Résolution / Proposition / Candidats</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Research feature, disable for the moment -->
        <!-- <div class="title-holder search">
        <input type="text" name="search_field" id="search_field" placeholder="Rechercher un scrutin" (keyup)="onResearchInput($event)">
      </div> -->
        <div *ngIf="users != null" style="height: 40px; margin-top: 24px">
          <p-dropdown
            [options]="users"
            [(ngModel)]="selectedUser"
            placeholder="Sélectionnez un utilisateur"
            [editable]="false"
            [showClear]="true"
            [filter]="true"
            optionLabel="email"
            filterBy="email, sub"
            (onChange)="filterPolls()">
            <ng-template let-users pTemplate="item">
              <div class="flex align-items-center operatingSystems-item">
                <div>{{users.email}} {{users.sub}}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div id="column-holder"
          *ngIf="plannedPolls.length != 0 || runningPolls.length != 0 || closedPolls.length != 0 || draftPolls.length != 0 else noPollsHolder">
          <vc-poll-column class="w-full" [isExpanded]="isExpanded[1]" [polls]="draftPolls" [enableDeletion]="true"
            pollTitle="{{'POLL-DASHBOARD.DRAFTS' | translate}}" [category]="0"
            [pollStatusIcon]="'assets/scheduled-poll-icon.svg'"
            [arrowIcon]="'assets/triangle-orange.svg'"></vc-poll-column>
          <vc-poll-column class="w-full" [isExpanded]="isExpanded[1]" [polls]="plannedPolls" [enableDeletion]="true"
            pollTitle="{{'POLL-DASHBOARD.PLANNED-POLLS' | translate}}" [category]="1"
            [super]="auth.getSuperAdmin(accountName)" [pollStatusIcon]="'assets/calendar-crossed.svg'"
            [arrowIcon]="'assets/triangle-blue.svg'"></vc-poll-column>
          <vc-poll-column class="w-full" [isExpanded]="isExpanded[1]" [polls]="runningPolls"
            pollTitle="{{'POLL-DASHBOARD.ONGOING-POLLS' | translate}}" [category]="2"
            [super]="auth.getSuperAdmin(accountName)" [pollStatusIcon]="'assets/ongoing_poll_icon.svg'"
            [arrowIcon]="'assets/triangle-green.svg'"></vc-poll-column>
          <vc-poll-column class="w-full" [isExpanded]="isExpanded[1]" [polls]="closedPolls"
            pollTitle="{{'POLL-DASHBOARD.FINISHED-POLLS' | translate}}" [category]="3"
            [pollStatusIcon]="'assets/ended-poll-icon.svg'" [arrowIcon]="'assets/triangle-red.svg'"></vc-poll-column>
        </div>
        <ng-template #noPollsHolder>
          <div class="no-polls-holder flex flex-column align-items-center content-center gap-20">
            <img src="assets/ballot-icon.svg" class="no-polls-image mb-20">
            <h2 class="no-polls-title dark-gray text-md no-margin">Aucun scrutin pour le moment,</h2>
            <p class="no-polls-description dark-blue text-md text-center mb-30 no-margin bold">
              CRÉEZ VOTRE PREMIER SCRUTIN POUR COMMENCER.
            </p>
            <img src="assets/hand-vote-icon.svg" class="no-polls-image mb-20">
            <!-- <div style="position: relative; display: inline-block;">
              <button (click)="newPoll()" style="min-width: 220px;" class="action-button mb-40">
                CRÉER UN SCRUTIN
              </button>
            </div> -->
            <div style="position: relative; display: inline-block;">
              <button
                (click)="pollCreationOptions(true)" style="min-width: 220px;" class="action-button">CRÉER UN SCRUTIN</button>
              <div *ngIf="secondPrePolToast" class="toaster p-20"
                style="position: absolute; top: -15%; left: 230px; width: 100%; margin-top: 10px; background-color: white; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.2); z-index: 1000;">
                <div class="flex align-items-center gap-5 poll-type-item" (click)="redirectToPap()">
                  <div class="play"></div>
                  <p class="pastel-pink no-margin">Election C.S.E</p>
                </div>
                <div class="flex align-items-center gap-5 poll-type-item mt-20" (click)="newPoll()">
                  <div class="play"></div>
                  <p class="lavender no-margin">Résolution / Proposition / Candidats</p>
                </div>
              </div>
            </div>

          </div>
        </ng-template>
      </main>

      <div style="margin-top: 62px; margin-right: 24px;">
        <p class="no-margin dark-gray text-sm">Premier pas</p>
        <p class="no-margin dark-blue bold text-sm">À VOTRE DISPOSITION :</p>
        <div class="flex info-section gap-10 mb-10 mt-20">
          <img src="assets/guide-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour réussir un scrutin</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadGuide()">Voir nos guides</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/docs-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour tout savoir,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="downloadDocuments()">Voir nos documents</p>
          </div>
        </div>

        <div class="flex info-section gap-10 mb-10">
          <img src="assets/support-icon.svg" alt="">
          <div>
            <p class="dark-blue no-margin text-sm">Pour toutes questions,</p>
            <p class="light-blue no-margin pointer text-sm" (click)="contactMail()">support_client&#64;v8te.com</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Popup to display more options -->
<vc-warning-popup class="MORE" *ngIf="moreOption" title="{{'PRICE-DETAILS.TITLE' | translate}}" [callButton]="true"
  [separator]="false" [cancelButton]="true" (endDetailsPopup)="openOffers($event)" [isAssoc]="isAssoc"
  [index]="selectedOffer">
</vc-warning-popup>

<!-- Popup to get contacted by v8te for more information -->
<vc-warning-popup class="CONTACTED" *ngIf="getContacted" [index]="-1" (endDetailsPopup)="dismissInitialPopup()"
  title="{{'DETAILS-CONTACT.TITLE' | translate}}" [phoneInput]="true" [understoodEndButton]="true"
  (contactPhone)="getContactPhone($event)"></vc-warning-popup>

<!-- Popup to confirm that the user will be contacted -->
<vc-warning-popup class="CONFIRMCOONTACT" *ngIf="confirmContact" title="{{'DETAILS-CONTACT.THANK' | translate}}"
  firstText="{{'DETAILS-CONTACT.CONFIRMATION' | translate}}" secondText="{{'DETAILS-CONTACT.CONTACT' | translate}}"
  [understoodEndButton]="true" (endDetailsPopup)="dismissInitialPopup()" [separator]="false"></vc-warning-popup>

<!-- Popups pour acheter une offre -->
<vc-offers-popup *ngIf="shouldBuyCredits" [isAssoc]="isAssoc" source="{{'dashboard'}}" (freeTrial)="newPoll()"
  (isClosed)="dismissPayPopup($event)" (moreInfoEmitter)="displayMoreInfo($event)"
  (displaySMSEmitter)="displaySMSOption($event)" (selectedOffer)="licenseService.buyOffer($event)"></vc-offers-popup>

<!-- Popups première connexion -->
<!-- <vc-warning-popup class="first-connection" *ngIf="shouldDisplayPopup" (endDetailsPopup)="dismissInitialPopup()"
  title="{{'WELCOME-POPUP.TITLE' | translate}}" firstText="{{'WELCOME-POPUP.LIMIT' | translate}}"
  secondText="{{'WELCOME-POPUP.CONTACT' | translate}}" [understoodButton]="true"></vc-warning-popup> -->

<vc-warning-popup class="confirm-edition-popup" *ngIf="editionDonePopup" (endDetailsPopup)="dismissInitialPopup()"
  title="{{'EDIT-POPUP.CONGRATS' | translate}}" [understoodButton]="true"></vc-warning-popup>

<!-- Popup to select an SMS option with the package -->
<!-- <vc-warning-popup class="SMS" *ngIf="smsAdditionalOption && !shoulDisplayChangePopup" [SMSOffers]="smsAdditionalOption"
  title="{{'PRICE-DETAILS.SMS-TITLE' | translate}}" [separator]="true" [noSMSButton]="true"
  (SMSOptionEmitter)="setSMSOption($event)" (endDetailsPopup)="dismissInitialPopup()" [isAssoc]="isAssoc">
</vc-warning-popup> -->

<!-- Popups confirmation achat -->
<div *ngIf="shouldDisplayNewLicences">
  <vc-warning-popup class="PURCHASE" (endDetailsPopup)="cancelNewLicencesPopup()"
    title="{{'POLL-PAYMENT.CONGRATS' | translate}}" firstText="{{'POLL-PAYMENT.UPDATE' | translate}}"
    secondText="{{'POLL-PAYMENT.DESCRIPTION' | translate}}"
    thirdText="{{'POLL-PAYMENT.NUMBER-1' | translate}} {{newLicences[0].nb}} {{'POLL-PAYMENT.NUMBER-2' | translate}}"
    [understoodButton]="true"></vc-warning-popup>
</div>

<!-- Popups confirmation achat hotline -->
<div *ngIf="hotlineConfirmation">
  <vc-warning-popup class="hotline-popup" (endDetailsPopup)="cancelNewLicencesPopup()"
    firstText="{{'POLL-PAYMENT.HOTLINE' | translate}}" [understoodButton]="true"></vc-warning-popup>
</div>

<!-- Popups si l'utilisateur a déjà un forfait -->
<!-- <vc-warning-popup class="YA" *ngIf="shoulDisplayChangePopup && smsAdditionalOption" [isAssoc]="clientType == 'assoc'"
  title="{{'PRICE-DETAILS.SMS-ON-CHANGE' | translate}}" [noSMSButton]="true" [separator]="true"
  [SMSOffers]="smsAdditionalOption" (SMSOptionEmitter)="setSMSOption($event)" (endDetailsPopup)="dismissInitialPopup()">
</vc-warning-popup> -->

<!-- Popups si l'utilisateur souhaite acheter un forfait -->
<!-- <vc-warning-popup class="hotline" *ngIf="hotlinePopup" [isAssoc]="clientType == 'assoc'"
  title="{{'HOTLINE.HOTLINE-TEXT' | translate}}" [cancelButton]="true" [separator]="true" [hotline]="true"
  (hotlineOptionEmitter)="licenseService.setHotlineOption($event, isAssoc)" (endDetailsPopup)="dismissInitialPopup()"
  [licenseTime]="licenseTime">
</vc-warning-popup> -->

<buy-options-popup *ngIf="shoulDisplayChangePopup" (endDetailsPopup)="dismissInitialPopup()" [licenseTime]="licenseTime"
  [isAssoc]="clientType == 'assoc'" (isClosed)="dismissChangePopup()" [SMSOffers]="smsAdditionalOption"
  (SMSOptionEmitter)="setSMSOption($event)"
  (hotlineOptionEmitter)="licenseService.setHotlineOption($event, isAssoc)"></buy-options-popup>
